import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { GetHodLeaveList, GetLeaveRejoinList } from "../../Repository/Api";
import { Link } from "react-router-dom";
import moment from "moment";
import { errorMsg } from "../Toastify";
import MUIDataTable from "mui-datatables";
import { DateRangePicker } from "react-date-range";
import { enUS } from 'date-fns/locale';
const HodLeaverequest = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [leaveList, setLeaveList] = useState([]);
  const [dummyleaveList, setdummyLeaveList] = useState([]);
  const [searchText, setSearchText] = useState('')

  const [dateFilterOpen, setDateFilterOpen] = useState(false)
  const filterIntialState = [
    {
      startDate: null,
      endDate: new Date('2030-01-01'),
      key: "selection",
    },
  ]
  const dfm = (date) => {
    return moment(date).format("DD/MM/yyyy")
  }
  const [range, setRange] = useState(filterIntialState);
  // console.log(range[0].startDate, "date range")
  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const dateFilterRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dateFilterRef.current && !dateFilterRef.current.contains(event.target)) {
      setDateFilterOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const SearchfilteredData = dummyleaveList?.filter(item =>
    Object.values(item).some(value =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setLeaveList(SearchfilteredData)
    } else {
      setLeaveList(dummyleaveList)
    }
  }, [searchText, dummyleaveList])


  useEffect(() => {
    getLeaveList();
  }, [range]);

  const [activetag, setActivetag] = useState(0);
  const linkstag = ["Applied Leave", "Cancelled Leave", "Rejoin"];
  const showSelectedtag = (index) => {
    setActivetag(index);
  };

  const [active, setActive] = useState(0);
  const links = [
    "Pending",
    "Approved",
    "Rejected",
    "Intimated (Out of Station)",
  ];
  const showSelected = (index) => {
    setActive(index);
  };

  const [activeone, setActiveone] = useState(0);
  const [activetwo, setActivetwo] = useState(0);
  const linksone = ["Pending", "Approved", "Rejected"];
  const linkstwo = ["Pending", "Approved"];
  const showSelectedone = (index) => {
    setActiveone(index);
  };
  const showSelectedtwo = (index) => {
    setActivetwo(index);
  };

  // Rejoin api-----------------------/
  const [RejoinList, setRejoinList] = useState([]);

  const GetRejoinList = async () => {
    const response = await GetLeaveRejoinList(token, linkstwo[activetwo].toLowerCase())
    if (response && response?.statusCode === 200) {
      const listData = response?.data?.joining_letter.filter(item => {
        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return ((startDate >= rangeStartDate && startDate <= rangeEndDate) || (endDate >= rangeStartDate && endDate <= rangeEndDate));
      })
      const rejoin = listData.map((rejoinData) => ({
        first_name: rejoinData.leave_detail.first_name,
        last_name: rejoinData.leave_detail.last_name,
        designation: rejoinData.leave_detail.designation,
        start_date: rejoinData.start_date,
        end_date: rejoinData.end_date,
        nature_of_leave: rejoinData.leave_detail.nature_of_leave,
        no_of_days: rejoinData.no_of_days,
        id: rejoinData.leave_detail.id
      }))
      setRejoinList(rejoin)
    }
  }
  useEffect(() => {
    GetRejoinList()
  }, [activetwo, range])

  // /--------------------------------/

  const getLeaveList = async () => {
    const response = await GetHodLeaveList(token);
    if (response && response.statusCode === 200) {

      // setLeaveList(response?.data?.leave_details);
      setdummyLeaveList(response?.data?.leave_details.filter(item => {
        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);
        const rangeStartDate = new Date(range[0].startDate)
        const rangeEndDate = new Date(range[0].endDate)
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        rangeStartDate.setHours(0, 0, 0, 0);
        rangeEndDate.setHours(0, 0, 0, 0);
        return ((startDate >= rangeStartDate && startDate <= rangeEndDate) ||( endDate >= rangeStartDate && endDate <= rangeEndDate));
      }))

    } else {
      errorMsg(response.message);
    }
  };
  const pendingLeaveLength = leaveList.filter(
    (item) => item.hod_status === "pending"
  ).length;
  const approveLeaveLength = leaveList.filter(
    (item) => item.hod_status === "approved"
  ).length;
  const rejectLeaveLength = leaveList.filter(
    (item) => item.hod_status === "rejected"
  ).length;
  const intimateLeaveLength = leaveList.filter(
    (item) => item.hod_status === "intimated"
  ).length;
  const pendingCancelLeaveLength = leaveList.filter(
    (item) => item.cancellation_hod_status === "pending"
  ).length;
  const approveCancelLeaveLength = leaveList.filter(
    (item) => item.cancellation_hod_status === "approved"
  ).length;
  const rejectCancelLeaveLength = leaveList.filter(
    (item) => item.cancellation_hod_status === "rejected"
  ).length;

  const AppliedpendingLeavelist = leaveList?.filter(leaveList => leaveList.hod_status === "pending")
  const AppliedApprovedLeavelist = leaveList?.filter(leaveList => leaveList.hod_status === "approved")
  const AppliedrejectedLeavelist = leaveList?.filter(leaveList => leaveList.hod_status === "rejected")
  const AppliedinimatedLeavelist = leaveList?.filter(leaveList => leaveList.hod_status === "intimated")
  const cancelledpendingCurrentitems = leaveList.filter((item) => item.cancellation_hod_status === "pending")
  const cancelledApprovedCurrentitems = leaveList.filter((item) => item.cancellation_hod_status === "approved")
  const cancelledRejectedCurrentitems = leaveList.filter((item) => item.cancellation_hod_status === "rejected")

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    viewColumns: false,
  };

  const columns = [
    {
      name: "first_name",
      label: "Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const lastName = tableMeta.rowData[1];
          return `${value} ${lastName}`;
        },
      },
    },
    {
      name: "last_name",
      label: "Last Name",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "designation",
      label: "Designation	",
    },
    // {
    //   name: "start_date",
    //   label: "Duration",
    //   options: {
    //     customBodyRender: (value, tableMeta) => {
    //       const endDate = tableMeta.rowData[4]
    //       return moment(value).format("DD MMM YY")
    //         + " - " + moment(endDate).format("DD MMM YY")
    //     },
    //     filter: false
    //   }
    // },
    {
      name: "start_date",
      label: "Duration",
      options: {
        customBodyRender: (value, tableMeta) => {
          const endDate = tableMeta.rowData[4];
          return moment(value, "YYYY-MM-DD HH:mm:ss").format("DD MMM YY") +
                 " - " +
                 moment(endDate, "YYYY-MM-DD HH:mm:ss").format("DD MMM YY");
        },
        filter: false
      }
    },
    
    {
      name: "end_date",
      label: "End Date",
      options: {
        display: false,
        filter: false
      },
    },
    {
      name: "nature_of_leave",
      label: "Types",
    },
    {
      name: "no_of_days",
      label: "Days",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <div>{Number.isInteger(value) ? value : value.toFixed(2)}</div>
          )
        }
      }
    },
    {
      name: "id",
      label: "More Info",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              to={`/app/Hod/HodSpecificrequestview/${value}`}
            >
              View Details
            </Link>
          )
        },
        filter: false,
        download: false
      }
    },
  ];


  let cancelledLeave
  if (activeone === 0) {
    cancelledLeave = cancelledpendingCurrentitems
  } else if (activeone === 1) {
    cancelledLeave = cancelledApprovedCurrentitems
  } else if (activeone === 2) {
    cancelledLeave = cancelledRejectedCurrentitems
  }

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="labeltitle">Leave Request</h6>
                  </div>
                  <div className="col-lg-7">
                    <ul className="searchtopflex">
                      {linkstag.map((linkt, index) => {
                        return (
                          <li
                            onClick={() => { showSelectedtag(index); setRange(filterIntialState) }}
                            key={linkt}
                            className={
                              activetag === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {linkt}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>

                {/* search */}
                {/* <div className="row justify-content-start mt-3">
                  <div className="col-lg-3">
                    <div class="input-group flex-nowrap">
                      <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
                      <input type="text" class="form-control search-table-data"
                        placeholder="Search"
                        aria-describedby="addon-wrapping"
                        name="search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </div>
                </div> */}
                {/* search */}
                <div className="mt-2">
                  {activetag === 0 && (
                    <>
                      <ul className="searchtopflex">
                        {links.map((link, index) => {
                          return (
                            <li
                              onClick={() => { showSelected(index); setRange(filterIntialState) }}
                              key={link}
                              className={
                                active === index
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {link}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      {active === 0 &&
                        <MUIDataTable
                          data={AppliedpendingLeavelist}
                          columns={columns}
                          options={options}
                          className="mt-3"
                        />
                      }
                      {active === 1 &&
                        <MUIDataTable
                          data={AppliedApprovedLeavelist}
                          columns={columns}
                          options={options}
                          className="mt-3"
                        />
                      }
                      {active === 2 &&
                        <MUIDataTable
                          data={AppliedrejectedLeavelist}
                          columns={columns}
                          options={options}
                          className="mt-3"
                        />
                      }
                      {active === 3 &&
                        <MUIDataTable
                          data={AppliedinimatedLeavelist}
                          columns={columns}
                          options={options}
                          className="mt-3"
                        />
                      }
                    </>
                  )}
                  {activetag === 1 && (
                    <>
                      <ul className="searchtopflex">
                        {linksone.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedone(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activeone === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={cancelledLeave}
                        columns={columns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                  {activetag === 2 && (
                    <>
                      <ul className="searchtopflex">
                        {linkstwo.map((linkone, indexone) => {
                          return (
                            <li
                              onClick={() => { showSelectedtwo(indexone); setRange(filterIntialState) }}
                              key={linkone}
                              className={
                                activetwo === indexone
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {linkone}
                            </li>
                          );
                        })}
                      </ul>
                      <div className="mt-3 d-flex align-items-center justify-content-end">
                        <div className="w-25 leave-filter-input" ref={dateFilterRef}>
                          <input
                            className="form-control"
                            defaultValue={range[0].startDate ? ((range[0].startDate.getTime() === range[0].endDate.getTime()) ? dfm(range[0].endDate) : dfm(range[0].startDate) + " - " + dfm(range[0].endDate)) : null}
                          />
                          <span
                            className="material-symbols-outlined leave-filter-calendar"
                            onClick={() => setDateFilterOpen(true)}
                          >
                            calendar_month
                          </span>
                          {dateFilterOpen && (
                            <DateRangePicker
                              ranges={range}
                              onChange={handleSelect}
                              locale={enUS}
                            />
                          )}
                        </div>
                        {range[0].startDate &&
                          <div>
                            <span
                              class="material-symbols-outlined ms-3 filter-reset-button"
                              onClick={() => setRange(filterIntialState)}
                            >
                              cancel
                            </span>
                          </div>}
                      </div>
                      <MUIDataTable
                        data={RejoinList}
                        columns={columns}
                        options={options}
                        className="mt-3"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HodLeaverequest;
